export default __webpack_public_path__ + "static/media/wedding.6684ed3c.svg";